"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var months_and_years_1 = require("../../common/constants/months_and_years");
var months_and_years_2 = require("../../common/constants/months_and_years");
var cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
var states_1 = require("../../common/constants/states");
var Teller_1 = require("../../../DriveScout/Billing/Teller");
var StudentOrdersController = /** @class */ (function () {
    function StudentOrdersController($stateParams, UsersModel, FlashService, UserService, VueStoreFactory, Stripe3DSService, canPurchaseNewServices) {
        var _this = this;
        this.$stateParams = $stateParams;
        this.student = UserService.getCurrentUser();
        this.loading = true;
        this.UsersModel = UsersModel;
        this.FlashService = FlashService;
        this.VueStoreFactory = VueStoreFactory;
        this.Stripe3DSService = Stripe3DSService;
        this.payment = {};
        this.orders = [];
        this.addresses = [];
        this.currentPage = 1;
        this.totalItems = 0;
        this.order = null;
        this.months = months_and_years_1.Months;
        this.years = months_and_years_2.Years;
        this.states = states_1.States;
        this.page_by = 10;
        this.gateway_config = {};
        this.canPurchaseNewServices = canPurchaseNewServices;
        this.pageChanged = this.pageChanged.bind(this);
        this.UsersModel.getPickupLocations(this.student.id).then(function (response) {
            _this.addresses = response.pickuplocations.map(function (location) {
                return location.address;
            });
        });
        // Read the billing policy synchronously from the Vuex store (populated at
        // student startup by student.module.ts getCurrentUser resolve) to get
        // gateway config for 3DS.
        var storePolicies = this.VueStoreFactory.state.auth.policies.policies;
        var billingPolicy = storePolicies.find(function (p) { return p.name === "billing"; });
        if (billingPolicy) {
            var policyMeta_1 = {};
            billingPolicy.policymeta.forEach(function (meta) {
                policyMeta_1[meta.meta_key] = meta.meta_value;
            });
            this.gateway = policyMeta_1.billing_gateway;
            this.gateway_config = {
                stripe_publishable_key: policyMeta_1.stripe_publishable_key,
            };
        }
        this.getOrders();
        this.inDollars = Teller_1.inDollars.bind(this);
    }
    StudentOrdersController.prototype.studentCanPurchaseNewServices = function () {
        return this.canPurchaseNewServices;
    };
    StudentOrdersController.prototype.pageChanged = function () {
        var _this = this;
        this.submitted = true;
        var payload = { student_id: this.student.id, page: this.currentPage };
        this.UsersModel.getStudentOrders(payload)
            .then(function (response) {
            _this.orders = response.orders.data;
            _this.totalItems = response.orders.total;
            _this.currentPage = response.orders.current_page;
            _this.submitted = false;
            _this.loading = false;
        })
            .catch(function (Error) {
            _this.loading = false;
        });
    };
    StudentOrdersController.prototype.getOrders = function () {
        var _this = this;
        this.submitted = true;
        var payload = { student_id: this.student.id };
        this.UsersModel.getStudentOrders(payload)
            .then(function (response) {
            _this.orders = response.orders.data;
            _this.totalItems = response.orders.total;
            _this.currentPage = response.orders.current_page;
            _this.submitted = false;
            _this.loading = false;
        })
            .catch(function (Error) {
            _this.loading = false;
        });
    };
    StudentOrdersController.prototype.addBillingAddress = function (index, address) {
        if (!this.payment.hasOwnProperty("card")) {
            this.payment.card = {};
        }
        this.payment.card.billing_address = address;
    };
    StudentOrdersController.prototype.submitPayment = function () {
        return __awaiter(this, void 0, void 0, function () {
            var payment, response, threeDSResult, confirmResponse, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submitted = true;
                        payment = (0, cloneDeep_1.default)(this.payment);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        return [4 /*yield*/, this.UsersModel.submitPayment(this.student.id, this.fee.id, {
                                payment: payment,
                            })];
                    case 2:
                        response = _a.sent();
                        if (!this.Stripe3DSService.isThreeDSecureRequired(response)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.Stripe3DSService.handle3DSChallenge(response.client_secret, this.gateway_config.stripe_publishable_key)];
                    case 3:
                        threeDSResult = _a.sent();
                        if (!threeDSResult.success) {
                            this.submitted = false;
                            this.FlashService.setMessage({
                                type: "error",
                                message: threeDSResult.error ||
                                    "Payment authentication failed. Please try again.",
                            });
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.Stripe3DSService.confirmFeePayment(this.student.id, this.fee.id, response.payment_intent_id, {
                                student_id: this.student.id,
                                fee_id: this.fee.id,
                                amount: response.amount,
                            })];
                    case 4:
                        confirmResponse = _a.sent();
                        this.handlePaymentSuccess(confirmResponse);
                        return [2 /*return*/];
                    case 5:
                        // Standard payment success (no 3DS required)
                        this.handlePaymentSuccess(response);
                        return [3 /*break*/, 7];
                    case 6:
                        error_1 = _a.sent();
                        this.submitted = false;
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    StudentOrdersController.prototype.handlePaymentSuccess = function (response) {
        var _this = this;
        this.submitted = false;
        this.FlashService.setMessage({
            type: "success",
            message: response.message,
        });
        // replace fee
        this.orders.forEach(function (_order, index) {
            if (_order.id === response.order.id) {
                _this.orders[index] = response.order;
            }
        });
        this.payment = {
            payment_method: "card",
        };
        this.fee = null;
    };
    return StudentOrdersController;
}());
StudentOrdersController.$inject = [
    "$stateParams",
    "UsersModel",
    "FlashService",
    "UserService",
    "VueStoreFactory",
    "Stripe3DSService",
    "canPurchaseNewServices",
];
exports.default = StudentOrdersController;
